import React from 'react';
import SettingsModal from './SettingsModal';

export default function SettingsPage({ stationId, onClose }) {
  return <SettingsModal stationId={stationId} onClose={onClose} />;
}
